import i18next from 'i18next';
import moment from 'moment';
import {Trans} from 'react-i18next';
import dictionaries from '../localization/dict';

const setLocale = (language = 'ru') => {
  moment.locale(language);
  i18next.init({
    lng: language,
    resources: {
      [language]: {
        translation: dictionaries[language],
      },
    },
  });

  document.title = language === 'ru'
    ? 'My new job - платформа для контактного подбора персонала и поиска работы'
    : 'My new job - platform for contact recruitment and job search';
};

const t = (key) => i18next.t(key);

const tTemplate = (key, value, tag) => {
  const rv = '%t%';
  const translatedString = i18next.t(key);
  const reg = new RegExp(rv, 'g');
  const replacedString = tag ? `<${tag}>${value}</${tag}>` : value;
  return translatedString.replace(reg, replacedString);
};

export {
  setLocale, t, i18next, Trans, tTemplate,
};


// let myString = "This sentence is an example sentence."
// let oldWord = " sentence"
// var reg = new RegExp(oldWord, "g");
// const t = myString.replace(reg, '');
